var YOUR_CLIENT_ID_GOOGLE = '169593418405-b3486cl4rf9onaf6r0e3tcsd7g74t98m.apps.googleusercontent.com';
var YOUR_CLIENT_ID_FACEBOOK = '214608450748157';
//var YOUR_REDIRECT_URI_GOOGLE = 'http://localhost:3000';
//var YOUR_REDIRECT_URI_FACEBOOK = 'http://localhost:3000';
var YOUR_REDIRECT_URI_GOOGLE = 'https://vsc24.net/vscZasady/zasady/Auth/Google';
var YOUR_REDIRECT_URI_FACEBOOK = 'https://vsc24.net/vscZasady/zasady/Auth/Facebook';

export function getHashToken () {
    const fragmentString = window.location.hash.substring(1)
    const regex = /([^&=]+)=([^&]*)/g
    let result: RegExpExecArray | null

    result = regex.exec(fragmentString)

    if (result !== null)
        return result[2]
    else
        return ''
}

//https://accounts.google.com/o/oauth2/v2/auth?client_id=169593418405-b3486cl4rf9onaf6r0e3tcsd7g74t98m.apps.googleusercontent.com&redirect_uri=http://localhost:3000&scope=https://www.googleapis.com/auth/userinfo.email+https://www.googleapis.com/auth/userinfo.profile&response_type=token
/*
   * Create form to request access token from Google's OAuth 2.0 server.
   */
export function oauth2SignInGoogle() {
   // Google's OAuth 2.0 endpoint for requesting an access token
   const oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

   // Parameters to pass to OAuth 2.0 endpoint.
   // var params = {'client_id': YOUR_CLIENT_ID,
   //               'redirect_uri': YOUR_REDIRECT_URI,
   //               'scope': 'https://www.googleapis.com/auth/userinfo.email+https://www.googleapis.com/auth/userinfo.profile',
   //               'response_type': 'token'};

   const scope = 'https://www.googleapis.com/auth/userinfo.email+https://www.googleapis.com/auth/userinfo.profile'
   const response_type = 'token'
   const oauth2Flow = `${oauth2Endpoint}?client_id=${YOUR_CLIENT_ID_GOOGLE}&redirect_uri=${YOUR_REDIRECT_URI_GOOGLE}&scope=${scope}&response_type=${response_type}`

   window.open(oauth2Flow, '_self')
}

//https://www.facebook.com/dialog/oauth?client_id=214608450748157&redirect_uri=http://localhost:3000&state={st=state123abc,ds=123456789}&response_type=token&scope=email,public_profile
export function oauth2SignInFacebook() {
   const oauth2Endpoint = 'https://www.facebook.com/dialog/oauth';
   const date = new Date();
   const h = date.getHours() < 10 ? "0" + date.getHours().toString() : date.getHours().toString();
   const m = date.getMinutes() < 10 ? "0" + date.getMinutes().toString() : date.getMinutes().toString();
   const s = date.getSeconds() < 10 ? "0" + date.getSeconds().toString() : date.getSeconds().toString();
   const ms = date.getMilliseconds() < 10 ? "00" + date.getHours().toString() : date.getMilliseconds() < 100 ? "0" + date.getMilliseconds().toString() : date.getMilliseconds().toString().toString();
   const dateStr: string = h + "." + m + "." + s + "." + ms;
   const state = dateStr + "-" + Math.floor(Math.random() * 10000000000).toString();
   const response_type = 'token';
   const scope = 'email,public_profile';
   const oauth2Flow = `${oauth2Endpoint}?client_id=${YOUR_CLIENT_ID_FACEBOOK}&redirect_uri=${YOUR_REDIRECT_URI_FACEBOOK}&state={st=${state}}&response_type=${response_type}&scope=${scope}`;

   window.open(oauth2Flow, '_self')
}
